import React from 'react';
import parse from 'html-react-parser';
import { useTranslation } from 'react-i18next';
import slugify from 'slugify';

import { OmaLummeApp } from '../../omaLummeContext';

import styles from './styles/CurrentNews.module.scss';

import Loading from '../Common/Loading';
// Utils.
import { cutString } from '../../utils/header';
// Images.
import defaultImage1 from '../../images/liftup-default-1.jpg';
import defaultImage2 from '../../images/liftup-default-2.jpg';
import defaultImage3 from '../../images/liftup-default-3.jpg';
// Types.
import { NewsLiftupProps } from '../../types/news';
import Button from '../Common/Button';

const CurrentNews: React.FunctionComponent<NewsLiftupProps> = (props: NewsLiftupProps) => {
  const { news } = OmaLummeApp.useState();

  const { activeArticle } = props;
  const { t } = useTranslation();

  const images = [defaultImage1, defaultImage2, defaultImage3];

  const numberOfArticlesToShow = news.length > 3 ? 3 : news.length;
  const articlesToShow = news
    .filter((article) => article !== activeArticle)
    .slice(0, numberOfArticlesToShow)
    .map((article, key) => {
      let liftUp = <Loading key={key} />;

      if (article && article.metaDescription) {
        const description = article.metaDescription;
        const cuttedDescription = cutString(description, 300);
        const descriptionToShow = parse(cuttedDescription);

        let liftUpImage = undefined;

        if (article.featuredImage) {
          liftUpImage = article.featuredImage;
        }

        liftUp = (
          <div className={`${styles.newsItem} newsLift col-4 col-md-6 col-lg-6`} key={key}>
            <div className={styles.top}>
              <img src={liftUpImage ? liftUpImage : images[key]} alt="" />
            </div>
            <div className={styles.bottom}>
              <h3 className="h2">{article.title}</h3>
              <p>{descriptionToShow}</p>
              <Button link={`/article/${slugify(article.title).toLowerCase()}`} className="buttonWhiteSmall" card noTab>
                {t('common:general.readMore')}
              </Button>
            </div>
          </div>
        );
      }
      return liftUp;
    });

  return <div className={styles.newsItems}>{articlesToShow}</div>;
};

export default CurrentNews;
